module.exports = __webpack_public_path__ + "img/77.0ceef1d2.jpg";